/**
 * Barra apilada de cash flow a 12 meses.
 *
 * Las alturas llegan ya normalizadas de la API (`incomeHeightPct` / `expensesHeightPct`),
 * calculadas contra el mes de mayor volumen. El cliente no normaliza: si lo hiciera, cada
 * pantalla que dibujara la serie podría escalarla distinto.
 */
import type { MonthlyCashflowPoint } from '@naar/shared';
import { cssPercent, formatEur } from '../lib/format';
import styles from './Charts.module.css';

interface StackedBarChartProps {
  data: MonthlyCashflowPoint[];
}

export function StackedBarChart({ data }: StackedBarChartProps) {
  return (
    <div className={styles.stacked}>
      {data.map((point) => (
        <div key={point.month} className={styles.stackedColumn}>
          <div
            className={styles.stackedTrack}
            title={`${point.label}: ingresos ${formatEur(point.income)} · gastos ${formatEur(
              point.expenses,
            )} · neto ${formatEur(point.net)}`}
          >
            <div
              className={styles.stackedExpense}
              style={{ height: cssPercent(point.expensesHeightPct) }}
            />
            <div
              className={styles.stackedIncome}
              style={{ height: cssPercent(point.incomeHeightPct) }}
            />
          </div>
          <div className={styles.axisLabel}>{point.label}</div>
        </div>
      ))}
    </div>
  );
}

/** Leyenda «Ingresos / Gastos» de la cabecera del gráfico. */
export function CashflowLegend() {
  return (
    <div className={styles.legend}>
      <span className={styles.legendItem}>
        <span
          className={styles.swatch}
          style={{ background: 'var(--naar-bar-income-swatch)' }}
        />
        Ingresos
      </span>
      <span className={styles.legendItem}>
        <span className={styles.swatch} style={{ background: 'var(--naar-bar-expense)' }} />
        Gastos
      </span>
    </div>
  );
}
